import React, { useEffect, useContext, useState, useRef } from 'react'
import {
  Box,
  CircularProgress,
} from '@mui/material';



const OverlayForSave = () => {

  return (
    <Box sx={{
      width:"100%",
      height:"100vh",
      position:"fixed",
      top:0,
      left:0,
      zIndex:999999999999999999,
      background:"rgba(0,0,0,0.7)",
      display:"flex",
      flexDirection:"column",
      gap:"30px",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"30px",
      color:"red",
      fontWeight:"bold"
    }}>
      <CircularProgress style={{ width:"75px", height:"75px", color:"red" }}/>
      Chargement ...
    </Box>
  )
};

export default OverlayForSave;
